/** Ziele & Rekorde (pages/ziele) und die Zielkarte auf „Heute". */
export default {
  page: {
    title: 'Ziele & Rekorde',
    titleMobile: 'Ziele',
    kickerGoals: { one: '{count} aktives Ziel', other: '{count} aktive Ziele' },
    kickerStreaks: { one: '{count} Serie', other: '{count} Serien' },
    addGoal: 'Ziel anlegen',
    loadError: 'Ziele lassen sich gerade nicht laden: {error}',
    yearGoals: 'Ziele {year}',
    moreGoals: 'Weitere Ziele',
    inactiveAria: 'Nicht aktive Ziele',
    inactive: 'Nicht aktiv',
    inactiveFrom: '{name} · ab {from}',
    inactiveFromTo: '{name} · ab {from} bis {to}',
    steps: 'Schritte',
    sleep: 'Schlaf',
    all: 'Alle',
    editAria: '{label} bearbeiten',
    streaks: 'Serien',
    streaksSub: 'Streng: ein verpasster Tag oder eine verpasste Woche beendet die Serie. Neue Regeln werden rückwirkend über alle Daten berechnet.',
    streaksError: 'Serien nicht verfügbar: {error}',
    addStreak: 'Serie anlegen',
    newStreak: 'Neue Serie',
    recordsError: 'Schnellste Stücke nicht verfügbar: {error}',
    removeStreakConfirm: 'Serie „{label}" entfernen? Sie lässt sich jederzeit neu anlegen und wird dann wieder rückwirkend berechnet.',
  },
  unit: {
    day: { one: 'Tag', other: 'Tage' },
    week: { one: 'Woche', other: 'Wochen' },
  },
  metric: {
    distance: 'Distanz',
    duration: 'Zeit',
    elevation: 'Höhenmeter',
    count: 'Anzahl',
    steps: 'Schritte pro Tag',
    sleep: 'Schlaf pro Nacht',
  },
  metricUnit: { elevation: 'hm', steps: 'Schritte' },
  goal: {
    perWeek: '{value}/Woche',
    barAria: '{actual} von {target}',
    barAriaExpected: '{actual} von {target}, Soll heute {pct}',
    expectedToday: 'Soll heute',
    lineLegend: 'Strich = Soll heute',
    pathAria: 'Zielpfad {label}',
    actual: 'Ist',
    target: 'Soll',
    forecast: 'Prognose',
    tooltipActual: 'Ist: {value}',
    endLabel: 'Ziel {target}',
    today: 'heute',
    outOfReach: 'Das Ziel ist mit dem bisherigen Tempo nicht mehr erreichbar.',
    behind: 'Mit etwas mehr pro Woche ist das Ziel noch drin.',
    adjust: 'Ziel anpassen',
    orKeep: 'oder als Erinnerung stehen lassen.',
    realistic: 'Realistisch erreichbar',
    neededFromToday: 'Soll ab heute',
    reached: 'erreicht',
    forecastTile: 'Prognose (Tempo letzte 8 Wochen)',
    ahead: 'Vorsprung zum Plan',
    gap: 'Abstand zum Plan',
    adjustQ: 'Ziel anpassen?',
    chartAria: 'Zielpfad: Soll-Linie bis {target}, Ist {actual}',
    chartAriaForecast: ', Prognose {forecast}',
    pathError: 'Zielpfad nicht verfügbar: {error}',
    legendTarget: 'Soll (linear)',
  },
  suggest: {
    aria: 'Noch keine Ziele',
    title: 'Noch keine Ziele',
    sub: 'Zum Beispiel die bisherigen Strava-Ziele übernehmen – oder ein eigenes anlegen.',
    run: 'Laufen {km} km im Jahr {year}',
    ride: 'Rad {km} km im Jahr {year}',
    yoga: 'Yoga 7× pro Woche',
    takeAll: 'Alle drei übernehmen',
    custom: 'Eigenes Ziel anlegen',
  },
  dialog: {
    perWeek: 'pro Woche',
    perMonth: 'pro Monat',
    perYear: 'pro Jahr',
    edit: 'Ziel bearbeiten',
    add: 'Ziel anlegen',
    valueError: 'Bitte einen Zielwert größer 0 eintragen.',
    deleteConfirm: 'Ziel wirklich löschen?',
    metric: 'Messgröße',
    sport: 'Sportart',
    allSports: 'Alle Sportarten',
    period: 'Zeitraum',
    value: 'Zielwert',
    validFrom: 'Gültig ab',
    validTo: 'Gültig bis (optional)',
    titleField: 'Titel (optional)',
    titlePlaceholder: 'wird sonst erzeugt',
    healthHint: 'Gesundheitsziele gelten pro Tag bzw. Nacht und vergleichen den Durchschnitt der letzten 30 Tage.',
    create: 'Anlegen',
  },
  records: {
    title: 'Schnellste Stücke Laufen',
    sub: 'Schnellstes Stück über die Strecke aus {runs} Läufen mit Verlauf, nicht nur ganze Läufe · Rahmen = neu in {year}',
    dnf: ' · Wettkampf, nicht beendet',
    fresh: ' · neu {year}',
    notYet: 'noch nicht gelaufen',
    recent: '90 Tage: {value}',
    aria: '{label}: {value} am {date}',
    ariaDnf: ', nicht beendet',
  },
  today: {
    aria: 'Ziele',
    title: 'Ziele {year}',
    all: 'Alle',
    add: 'Ziel anlegen',
    empty: 'Noch keine Ziele. Jahres- und Wochenziele mit Prognose legst du unter „Ziele" an.',
    done: 'erledigt',
    open: 'offen',
  },
  streak: {
    weekFrom: 'Woche ab {date}',
    cellOpen: '{when}: noch offen',
    cellOk: '{when}: erfüllt',
    cellOkCount: { one: '{when}: erfüllt ({count} Aktivität)', other: '{when}: erfüllt ({count} Aktivitäten)' },
    cellNear: '{when}: knapp verpasst – unter dem Mindestwert',
    cellMissed: '{when}: nicht erfüllt',
    cellsAriaDays: 'Letzte {n} Tage: {ok} erfüllt',
    cellsAriaWeeks: 'Letzte {n} Wochen: {ok} erfüllt',
    cellsAriaOpen: ', der laufende Zeitraum ist offen',
    legendCurrent: 'laufende Serie',
    legendEarlier: 'erfüllt, frühere Serie',
    legendMissed: 'verpasst',
    legendNear: 'knapp verpasst',
    legendTodayOpen: 'heute offen',
    legendWeekOpen: 'diese Woche offen',
    record: 'Rekord: {n}',
    running: ' (läuft)',
    before: ' · davor {n}',
    noRecord: 'noch kein Rekord',
    removeAria: '{label} entfernen',
    lastHit: 'Letzter Treffer:',
    since: 'Seit:',
    longest: 'Rückwirkend längste:',
    near: 'Knapp verpasst:',
    nearText: { one: '{count} Tag unter dem Mindestwert (zuletzt {value} am {date})', other: '{count} Tage unter dem Mindestwert (zuletzt {value} am {date})' },
    thisWeek: 'Diese Woche:',
    haveOf: '{have} von {need}',
    previewNone: 'Mit dieser Regel gäbe es bisher noch keinen erfüllten Zeitraum.',
    previewLongest: 'Mit dieser Regel wäre deine längste Serie {longest} gewesen ({range}).',
    previewNow: ' Sie liefe gerade seit {now}.',
    previewStrictDay: '{preview} Streng – ein verpasster Tag beendet die Serie. Kalendertag nach Ortszeit des Starts, Laufband zählt.',
    previewStrictPeriod: '{preview} Streng – ein verpasster Zeitraum beendet die Serie. Kalendertag nach Ortszeit des Starts, Laufband zählt.',
    incomplete: 'Bitte die Regel vervollständigen.',
    computing: 'Vorschau wird berechnet …',
    preview: 'Vorschau: {text}',
    sport: 'Sportart',
    anyActivity: 'Jede Aktivität',
    rhythm: 'Rhythmus',
    everyDay: 'Jeden Tag',
    everyWeek: 'Jede Woche',
    perWeek: 'x-mal pro Woche',
    perWeekAria: 'Wie oft pro Woche',
    atLeast: 'Mindestens',
    mile: '1 Meile ({km})',
    distance: 'Distanz …',
    duration: 'Dauer …',
    noLimit: 'Keine Grenze',
    minDistAria: 'Mindestdistanz in km',
    minDurAria: 'Mindestdauer in Minuten',
    counting: 'Gezählt wird',
    single: 'eine einzelne Aktivität',
    daySum: 'Summe des Tages',
    newStreak: 'Neue Serie',
    create: 'Anlegen',
    createStreak: 'Serie anlegen',
  },
};
